import { object, SchemaOf } from 'yup';
import {validateEmail, validateName, validatePassword} from 'lib/utils/inputValidation';
import { CreateAccountFields, CreateAccountSchema } from './types';

export const createAccountSchemaValidation: SchemaOf<CreateAccountSchema> = object().shape({
  [CreateAccountFields.first_name]: validateName.required('First name is required'),
  [CreateAccountFields.last_name]: validateName,
  [CreateAccountFields.email]: validateEmail,
  [CreateAccountFields.password]: validatePassword,
});
